import DegreeTable from '../components/DegreeTable';
import { useNavigate } from 'react-router-dom';

const Degree = () => {
     const navigate = useNavigate();
     return (
          <div>
               <div className="page-header d-flex justify-content-between align-items-center mb-3">
                    <h2>Degree Master</h2>
                    <button className="btn btn-primary btn-sm" onClick={() => navigate('/degrees/add')}>Add Degree</button>
               </div>
               <DegreeTable />
          </div>
     );
};

export default Degree;